// extracted by mini-css-extract-plugin
export default {"accessCheck":"styles_accessCheck__jELyc","disabeldAccessCheck":"styles_disabeldAccessCheck__0Dh6T"};